<template>
  <!-- Coupon List -->
  <div class="nearby-coupons">
    <!-- Loading indicator -->
    <div v-if="loading && nearbyCoupons.length === 0" class="loading-state">
      <p>正在加载优惠券...</p>
    </div>
    
    <!-- Coupon list with infinite scroll -->
    <div v-if="nearbyCoupons.length > 0" class="coupon-list" v-infinite-scroll="inScorll" :infinite-scroll-delay="1500" :infinite-scroll-immediate="false">
      <div v-for="(item, index) in nearbyCoupons" :key="index" class="coupon-item">
        <!-- Business Type Tag -->
        <div class="coupon-tag" :style="{ backgroundColor: getBusinessTypeColor(item.businessType) }">
          {{ getBusinessTypeName(item.businessType) }}-{{getTemplateTypeName(item.templateTypeId)}}
        </div>

        <!-- Coupon Content -->
        <div class="coupon-content">

          <!-- Middle Row: Business Entity and Validity -->
          <div class="coupon-info" >
            <div class="coupon-business" style="text-align: center">
              {{ item.busiEntityName || '未知场所' }}

              <!-- Add distance display -->
              <div class="coupon-distance" v-if="item.distance !== null && item.distance !== undefined">
                <i class="el-icon-location"></i>
                {{ formatDistance(item.distance) }}
              </div>

              <div class="coupon-validity" v-if="item.validStartTime && item.validEndTime">
                {{ item.validStartTime }} - {{ item.validEndTime }}
              </div>
            </div>

          </div>

          <!-- Bottom Row: Values and Remaining Count -->
          <div class="coupon-footer">
            <div class="coupon-details">
              <div class="coupon-value">
                <span class="amount-value">{{ formatDiscountValue(item.discountValue || item.templateValue || 0, item.templateType || item.typeId) }}</span>
                <span class="amount-unit">{{ formatDiscountUnit(item.templateType || item.typeId) }}</span>
              </div>

              <div class="coupon-remaining">
                剩余: {{ formatRemainingCount(item.quantity, item.usedQuantity) }}
              </div>

              <!-- Action Button -->
              <div class="coupon-action">
                <el-button
                    :type="item.distributionPrice > 0 ? 'danger' : 'primary'"
                    size="small"
                    @click.stop="onCouponAction(item)">
                  {{ item.distributionPrice > 0 ? `${item.distributionPrice}元购买` : '免费领取' }}
                </el-button>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <!-- Loading more indicator -->
      <div v-if="loading && nearbyCoupons.length > 0" class="loading-more">
        <span>加载更多...</span>
      </div>
      
      <!-- No more data indicator -->
      <div v-if="!hasMoreData && nearbyCoupons.length > 0" class="no-more-data">
        <span>没有更多数据了</span>
      </div>
    </div>
    
    <!-- Empty state -->
    <div v-else-if="!loading" class="empty-state">
      <el-empty description="暂无可用优惠券"></el-empty>
    </div>
  </div>
</template>

<script>
// eslint-disable-next-line no-unused-vars
import {getNearByCoupons, listPublicCoupons, purchaseCoupon, listCouponsByBusiness} from "@/api/coupon/couponRelease";
import {populateBusiEntityNames} from "@/utils/couponUtils";
import {ElMessage} from "element-plus";
// eslint-disable-next-line no-unused-vars
import { useRouter } from 'vue-router'

export default {
  name: 'ParkingDiscounts',
  components: { },
  props: {
    modelValue: {
      type: [String, Array, Object],
      default: ''
    },
    // refreshKey: {
    //   type: Number,
    //   default: 0
    // },
    userLocation: {
      type: Object,
      default: null
    },
    businessEntityId: {
      type: Number,
      default: null
    },
    searchText: {
      type: String,
      default: ''
    }
  },
  emits: ['update:modelValue', 'validate', 'handle-coupon-action'],
  data() {
    return {
      loading: false,
      nearbyCoupons: [],
      switchPage: false,
      hasMoreData: true,
      query:{
        pageNum:1,
        pageSize: 6,
      },
      localSearchText: this.searchText
      // userLocation: null,
      // refreshKey: 0
    }
  },
  created() {
    // Ensure we fetch data on component creation, even if userLocation is null
    // this.fetchNearbyCoupons();
  },
  watch: {
    // refreshKey: {
    //   handler() {
    //     console.log(77777);
    //     this.fetchNearbyCoupons();
    //   },
    //   immediate: true // Trigger immediately on component creation
    // },

    userLocation(newVal, oldVal) {
      console.log('userLocation changed:', {
        from: oldVal,
        to: newVal
      });
      this.resetPagination();
      this.fetchNearbyCoupons();
    },
    businessEntityId(newVal, oldVal) {
      console.log('businessEntityId changed:', {
        from: oldVal,
        to: newVal
      });
      this.resetPagination();
      this.fetchNearbyCoupons();
    },
    searchText(newVal) {
      console.log("searchText changed", newVal)
      this.localSearchText = newVal;
      this.resetPagination();
      this.fetchNearbyCoupons();
    }
  },
  methods: {
    triggerSearch(searchTerm) {
      console.log("triggerSearch")
      this.localSearchText = searchTerm;
      this.resetPagination();
      this.fetchNearbyCoupons();
    },

    resetPagination() {
      this.query.pageNum = 1;
      this.nearbyCoupons = [];
      this.switchPage = false;
      this.hasMoreData = true;
    },

    async fetchNearbyCoupons(){
      // Prevent multiple simultaneous calls
      if (this.loading) {
        // console.log('Already loading, skipping fetch');
        return;
      }
      
      // Prevent calls when there's no more data
      if (!this.hasMoreData) {
        console.log('No more data available, skipping fetch');
        return;
      }
      
      this.loading = true;
      this.switchPage = false;
      
      try {
        let response;

        if (this.userLocation?.latitude && this.userLocation?.longitude) {
          // Use location if available
          const { latitude, longitude } = this.userLocation;
          response = await getNearByCoupons(this.query.pageNum, this.query.pageSize, latitude, longitude, 5000, this.localSearchText);
          console.log('fetchNearbyCoupons pageNum:', this.query.pageNum, ' location:', { latitude, longitude }, response.rows);
          
          // If nearby API returns no results, fallback to public coupons
          if (!response.rows || response.rows.length === 0) {
            console.log('No nearby coupons found, falling back to public coupons');
            response = await listPublicCoupons(this.query);
            console.log('Fallback to public coupons:', response.rows);
          }
        } else if(this.businessEntityId){
          response = await listCouponsByBusiness(this.query.pageNum, this.query.pageSize, 1, this.businessEntityId);
          console.log('fetchNearbyCoupons pageNum:', this.query.pageNum, ' businessEntityId:', this.businessEntityId, response.rows);
        } else {
          response = await listPublicCoupons(this.query);
          console.log('fetchNearbyCoupons public pageNum:', this.query.pageNum, response.rows, this.userLocation, this.userLocation?.latitude && this.userLocation?.longitude);
        }

        console.log('API response:', response);

        if (response && response.rows) {
          // Process entity names with caching (optimized)
          let entityData = await populateBusiEntityNames(response.rows);

          // Debug: Log distance information
          console.log('Coupons with distance info:', entityData.map(item => ({
            id: item.id,
            name: item.busiEntityName,
            distance: item.distance,
            businessType: item.businessType,
            busiEntityId: item.busiEntityId
          })));
          
          // Check if we're getting duplicate data (same items as before)
          if (this.query.pageNum > 1 && entityData.length > 0) {
            const firstNewItem = entityData[0];
            const existingItem = this.nearbyCoupons.find(item => item.id === firstNewItem.id);
            if (existingItem) {
              console.log('Duplicate data detected, stopping pagination');
              this.switchPage = false;
              this.hasMoreData = false;
              return;
            }
          }
          
          // Append new data to existing list for pagination
          this.nearbyCoupons = [...this.nearbyCoupons, ...entityData];
          
          // Check if there are more pages
          if(response.rows.length >= this.query.pageSize){
            this.query.pageNum++;
            console.log("pageNum++", this.query.pageNum, response.rows.length, this.query.pageSize)
            this.switchPage = true;
            this.hasMoreData = true;
          } else {
            this.switchPage = false;
            this.hasMoreData = false;
            console.log("No more pages available, stopping pagination");
          }

          console.log('Processed coupons with entity names:', this.nearbyCoupons);
        } else {
          if (this.query.pageNum === 1) {
            this.nearbyCoupons = [];
          }
          this.switchPage = false;
          this.hasMoreData = false;
          console.log('No coupons data found in response, stopping pagination');
        }
      } catch (error) {
        console.error('Error fetching nearby coupons:', error);
        ElMessage.error('获取优惠券数据失败');
        if (this.query.pageNum === 1) {
          this.nearbyCoupons = [];
        }
        this.switchPage = false;
        this.hasMoreData = false;
      } finally {
        this.loading = false;
      }
    },

    formatDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },

    inScorll(){
      if(this.switchPage && !this.loading && this.hasMoreData){
        console.log('Infinite scroll triggered, loading more coupons...');
        this.fetchNearbyCoupons();
      } else if (!this.hasMoreData) {
        console.log('No more data available, pagination stopped');
      } else if (this.loading) {
        console.log('Already loading, skipping infinite scroll');
      } else if (!this.switchPage) {
        console.log('Pagination disabled, no more pages');
      }
    },

    // New method to format distance
    formatDistance(distance) {
      if (distance === null || distance === undefined) return '未知距离';
      if (distance >= 999) return '距离未知';
      if (distance < 1) {
        return `${(distance * 1000).toFixed(0)}米`;
      } else {
        return `${distance.toFixed(1)}公里`;
      }
    },
    // Add a function to get business type name based on type code
    getBusinessTypeName(type) {
      // Convert numeric values from backend to string representations
      if (type === 1) return '停车';
      if (type === 2) return '充电';
      if (type === 3) return '洗车';
      if (type === 4) return '物业';

      // For string values (if already converted)
      if (type === 'parking') return '停车';
      if (type === 'charging') return '充电';
      if (type === 'washing') return '洗车';
      if (type === 'property') return '物业';

      return '通用';
    },

    // Get tag color based on business type
    getBusinessTypeColor(type) {
      // Convert numeric values from backend
      if (type === 1) return '#3d8bfd';  // 停车 - Blue
      if (type === 2) return '#20c997'; // 充电 - Green
      if (type === 3) return '#fd7e14';  // 洗车 - Orange
      if (type === 4) return '#6f42c1'; // 物业 - Purple

      // For string values
      if (type === 'parking') return '#3d8bfd';
      if (type === 'charging') return '#20c997';
      if (type === 'washing') return '#fd7e14';
      if (type === 'property') return '#6f42c1';

      return '#adb5bd'; // Default - Gray
    },

    formatDiscountValue(value, type) {
      // Debug to see what's being passed
      // console.log(`Formatting discount value: ${value}, type: ${type}`);

      // Handle null, undefined or empty values
      if (value === null || value === undefined || value === '') {
        return '0';
      }

      // Try multiple property names (API inconsistency fix)
      let numValue;
      if (typeof value === 'object') {
        // If it's an object, try to extract the value from it
        numValue = parseFloat(value.value || value.amount || Object.values(value)[0] || 0);
      } else {
        // Convert to number if it's a string or number
        numValue = parseFloat(value);
      }

      // Handle NaN
      if (isNaN(numValue)) {
        console.warn('Could not parse discount value:', value);
        return '0';
      }

      const typeId = parseInt(type);

      switch(typeId) {
        case 1: // Cash amount
          return numValue.toFixed(2);
        case 2: // Percentage discount
          return numValue.toFixed(1);
        case 3: // Hours
          return numValue.toString();
        default:
          return numValue.toFixed(2); // Default to 2 decimal places for money values
      }
    },

    formatDiscountUnit (type) {
      switch (type) {
        case '1': return '元';
        case '2': return '小时';
        case '3': return '折';
        default: return '';
      }
    },
    getTemplateTypeName(type) {
      if (type === 1) return '停车';
      if (type === 2) return '充电';
      if (type === 3) return '洗车';
      if (type === 4) return '物业';
      return '通用';
    },

    // Format remaining count
    formatRemainingCount(total, used) {
      if (total === undefined || total === null) return '未知';
      const usedCount = used || 0;
      const remaining = total - usedCount;
      return `${remaining}/${total}`;
    },

    /**
     * NEW METHOD: Renamed to make its purpose clearer
     * Simply emit the event to parent component for handling
     */
    onCouponAction(coupon) {
      console.log('ParkingDiscounts: Emitting handle-coupon-action with coupon:', coupon);
      this.$emit('handle-coupon-action', coupon);
    },

    /**
     * Clear cache and refresh data
     */
    async refreshData() {
      console.log('Refreshing data and clearing cache...');
      
      // Import and clear the cache
      const { clearEntityCache } = await import('@/utils/couponUtils');
      clearEntityCache();
      
      // Reset pagination
      this.query.pageNum = 1;
      this.nearbyCoupons = [];
      
      // Fetch fresh data
      await this.fetchNearbyCoupons();
    },
  },
}
</script>

<style scoped>

.keyboard-row button {
  width: 44px;
  height: 44px;
  border: none;
  border-radius: 4px;
  background-color: white;
  font-size: 18px;
  cursor: pointer;
}

.keyboard-row button:hover {
  background-color: #e6e6e6;
}

@media (max-width: 376px) {

  .keyboard-row button {
    width: 36px;
    height: 36px;
    font-size: 16px;
  }
}

.coupon-tag {
  position: absolute;
  top: 0;
  left: 0;
  padding: 4px 8px;
  color: white;
  font-size: 12px;
  border-top-left-radius: 4px;
  border-bottom-right-radius: 8px;
  z-index: 1;
}

.location-left .el-icon {
  margin-right: 5px;
  color: #999;
}

/* Coupon List */
.nearby-coupons {
  padding: 15px;
}

.coupon-list {
  margin-top: 10px;
}

.coupon-item {
  position: relative;
  background-color: white;
  border-radius: 8px;
  margin-bottom: 8px;
  padding: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.coupon-content {
  padding-top: 3px;
}

.coupon-info {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 8px;
  font-size: 14px;
  color: #171718e3;
}

.coupon-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 6px;
}

.coupon-value {
  font-size: 20px;
  font-weight: bold;
  color: #f56c6c;
}
.amount-unit {
  font-size: 12px;
  font-weight: bold;
  color: #319bf1;
}
.coupon-details {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr; /* Two equal columns */
  align-items: center;
  width: 100%;
}

.coupon-remaining {
  font-size: 12px;
  color: #909399;
  text-align: center;
}

.coupon-distance {
  font-size: 12px;
  color: #409eff;
  margin-top: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
}

.coupon-distance i {
  font-size: 14px;
}

.coupon-action {
  margin-top: 12px;
  text-align: right;
}

.empty-state {
  margin-top: 40px;
  margin-bottom: 40px;
}

/* Add loading and empty states */
.loading-state, .empty-state {
  padding: 20px;
  text-align: center;
  color: #999;
}

.loading-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}

.loading-more {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px 0;
  color: #999;
  gap: 8px;
}

.no-more-data {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px 0;
  color: #999;
  font-size: 14px;
}

.debug-panel {
  padding: 10px;
  background-color: white;
  border-top: 1px solid #f5f5f5;
}

.validity, .distance, .address {
  display: block;
  width: 100%;
  text-align: center;
  margin: 4px 0;
  color: #333; /* Make sure text is visible */
}

/* Target the purchase buttons and change their background color to blue */
.coupon-purchase,
button.purchase,
.btn-purchase,
.buy-button {
  background-color: #1890ff !important; /* Blue color, using !important to override existing styles */
  color: white !important;
  border-color: #1890ff !important;
}

/* If you can inspect and find the exact class name, use that instead */
/* Example if the buttons have a specific class */
.coupon-action .el-button,
.purchase-btn {
  background-color: #1890ff !important;
  color: white !important;
  border-color: #1890ff !important;
}
</style>
